import { LogLevel } from '../models';
import { ILoggingPublisher } from './logging-publisher.interface';

export class LoggingLocalFiles implements ILoggingPublisher {
	/* eslint-disable @typescript-eslint/no-unused-vars */
	public async log(title: string, body: string, level: LogLevel): Promise<void> {}
}
